import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDBodyText, FDBox,
  FDHeadlineText,
  FDStack,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import MetaControl from 'Components/UI/Meta/MetaControl';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import {
  TaxStrategyGeneralAccordionGroup,
} from './TaxStrategyGeneralAccordionGroup';
import {
  TaxStrategyTopWaysToSaveAccordionGroup,
} from './TaxStrategyTopWaysToSaveAccordionGroup';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'sm', align: 'center' },
  }, overrideReadOnly)
  .nameOverride(['subtitle'], {
    _component: () => FDBodyText,
    _customProps: { align: 'center' },
  }, overrideReadOnly);

export const TaxSavingsSectionLayout = ({
  resource,
}) => {
  return (
    <FDStack
      direction={'column'}
      spacing={6}
      maxWidth={800}
      alignSelf={'center'}
      {...dataAttrs('tax-strategy-detail-tax-savings-section')}
    >
      <FDStack direction={'column'} spacing={3}>
        <MetaControl resource={resource} metaOverrideSet={metaOverrides} attrName={'title'} />
        <FDBox margin={'auto'} maxWidth={725}>
          <MetaControl resource={resource} metaOverrideSet={metaOverrides} attrName={'subtitle'} />
        </FDBox>
      </FDStack>
      <FDStack direction={'column'} spacing={1}>
        <TaxStrategyTopWaysToSaveAccordionGroup resource={resource} />
        <TaxStrategyGeneralAccordionGroup resource={resource} />
      </FDStack>
    </FDStack>
  );
};

TaxSavingsSectionLayout.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
